import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import { Label, utils } from '@adc/ui-core'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)
const { ColorHash } = utils

class LabelCell extends Component {
  static colorHash = new ColorHash()

  static propTypes = {
    rowIndex: PropTypes.number,
    definition: PropTypes.object.isRequired,
    data: PropTypes.array,
  }

  renderLabels = labels =>
    labels.map(label => (
      <Label
        style={{ backgroundColor: LabelCell.colorHash.hex(label) }}
        className={cx('label')}
        size='small'
        key={label}
      >
        {label}
      </Label>
    ))

  render() {
    const { rowIndex, definition, data, ...props } = this.props
    const { field } = definition
    const baseField = field.substring(field.lastIndexOf('.') + 1)
    const row = data[rowIndex]
    return (
      <Cell
        data-elm-id={`${baseField}_${rowIndex}`}
        className={cx('cell')}
        {...props}
      >
        <div
          style={{
            width: DataTableUtils.getCellInnerWidth(definition.colProps),
          }}
          className={cx('text-truncate')}
        >
          {this.renderLabels(row[baseField] || [])}
        </div>
      </Cell>
    )
  }
}

export default LabelCell
